module.exports = __webpack_public_path__ + "static/img/taekwondo_klub_novi_grad_sarajevo.9aa38fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/taekwondo_klub_novi_grad_sarajevo.png
// module id = eZSh
// module chunks = 0